import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgLink = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.141 4.798a4.75 4.75 0 0 1 6.718 0l.343.343a4.75 4.75 0 0 1 0 6.718L17.53 13.53a.75.75 0 1 1-1.06-1.06l1.671-1.672a3.25 3.25 0 0 0 0-4.596l-.343-.343a3.25 3.25 0 0 0-4.596 0L11.53 7.53a.75.75 0 1 1-1.06-1.06zm3.39 3.672a.75.75 0 0 1 0 1.06l-6 6a.75.75 0 0 1-1.061-1.06l6-6a.75.75 0 0 1 1.06 0m-8 2a.75.75 0 0 1 0 1.06l-1.672 1.672a3.25 3.25 0 0 0 0 4.596l-.53.53.53-.53.343.343a3.25 3.25 0 0 0 4.596 0l1.672-1.671a.75.75 0 1 1 1.06 1.06l-1.671 1.672a4.75 4.75 0 0 1-6.718 0l-.343-.343a4.75 4.75 0 0 1 0-6.718L6.47 10.47a.75.75 0 0 1 1.06 0"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgLink;
